
import mitt from 'mitt'
type Events = {
  loginSuccess: void
}
export const emitter = mitt<Events>()